import { resolvePresetModelUrl } from './presetModels'

export type MeshExampleKey = 'damagedHelmet' | 'horse' | 'ktx2Mixed'

export interface MeshExampleModel {
  key: MeshExampleKey
  title: string
  description: string
  url: string
}

// 与 3DGS 预设模型共用部署策略：模型仅在线上服务器维护，不进入 example 构建产物。
export const MESH_EXAMPLE_MODELS: Record<MeshExampleKey, MeshExampleModel> = {
  ktx2Mixed: {
    key: 'ktx2Mixed',
    title: 'KTX2 / PNG 混合纹理',
    description: '自制 2048 色块及透明窗口：KTX2 与 PNG 共用纹理尺寸上限，验证 mip 选择与图片缩放。',
    url: '/mesh-ktx2-fixtures/mixed.gltf',
  },
  damagedHelmet: {
    key: 'damagedHelmet',
    title: 'Damaged Helmet',
    description: '加载带外部 BIN 与 PBR 纹理依赖的 glTF 模型。',
    url: resolvePresetModelUrl('/mesh-models/damagedHelmet/glTF/DamagedHelmet.gltf'),
  },
  horse: {
    key: 'horse',
    title: 'Horse',
    description: '加载单文件 GLB，验证静态 Mesh 与内嵌资源链路。',
    url: resolvePresetModelUrl('/mesh-models/horse/Horse.glb'),
  },
}
